module.exports = __webpack_public_path__ + "img/ug311.803f51b9.png";